export const fetchWithRetry = async (request, retries = 2, delay = 1000) => {
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      // Clone the request each time so body isn't consumed
      const clonedRequest = request.clone();

      const response = await fetch(clonedRequest);

      if (response.ok) {
        return response;
      }

      // Retry only for specific errors
      if (response.status  === 408 || response.status === 500) {
        if (attempt < retries) {
          await new Promise(res => setTimeout(res, delay));
          continue; // Retry
        }
      }

      // Other errors – don't retry, just return
      return response;
    } catch (err) {
      if (attempt < retries) {
        await new Promise(res => setTimeout(res, delay));
        continue; // Retry
      }
      const errorMessage = err?.message || "Failed to fetch";
      return new Response(
        JSON.stringify({
          statusCode: 503,
          status: 503,
          message: errorMessage,
          errors: {
            errorPayload: {
              error: {
                message: errorMessage,
              },
            },
          },
        }),
        {
          status: 503,
          statusText: "Service Unavailable",
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  }
};
